const fundFamilyStatus = [
  { id: 'ACTIVE', name: 'Active' },
  { id: 'PENDING', name: 'Pending' }
];

export { fundFamilyStatus };
